import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { SpinnerSize } from 'frontcore/views/loaders/spinner/types'

interface Props {
  size?: SpinnerSize
  colorCssVar?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CoreSpinner',
  props: {
    size: { default: SpinnerSize.DEFAULT },
    colorCssVar: { default: 'core-primary-60' }
  },
  setup(__props: any) {

const props = __props

const sizeClasses = {
  [SpinnerSize.SMALL]: 'spinner-small-size tw-w-6 tw-h-6',
  [SpinnerSize.DEFAULT]: 'spinner-default-size tw-w-10 tw-h-10',
}

const sizeClass = computed(() => {
  return sizeClasses[props.size]
})

const colorStyle = computed<Record<string, string>>(() => {
  return { '--core-spinner-color': `var(--${props.colorCssVar})` }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-test": "core-loading",
    class: _normalizeClass(["spinner tw-rounded-full", [sizeClass.value]]),
    style: _normalizeStyle(colorStyle.value)
  }, null, 6))
}
}

})